import { Command } from '@workbuddy/ui/model';
import { EntityViewRecordScope } from '@jms/model';
import { SettingsPanelBuilder } from '@workbuddy/ui/v2/blocks/settings.panel';
import { resolveDefaultRecordScope, resolveRecordScopeOptions } from '../../../state/features/with.metadata';
import { ViewAdapterContext, ViewAdapterDeps, ViewStepAdapter } from './view.step.adapter';

/**
 * Step 1 — record-scope gate. Only reachable when the active entity's
 * metadata declares a `secondaryFilter`; the wizard skips straight to
 * the terminal step otherwise.
 *
 * Labels come from each entity's `displayName` (e.g. "Jobs" / "Stages")
 * — the user never sees the internal "primary/secondary" enum.
 */
export function createSetupAdapter(deps: ViewAdapterDeps): ViewStepAdapter {

  return {
    build: (ctx, model, wizard) => {

      const config = deps.$config();
      const metadata = config.metadata ?? null;
      const scopeOptions = resolveRecordScopeOptions(metadata, config.recordScopes);
      const selectedScope = model.recordScope
        ?? resolveDefaultRecordScope(metadata, config.recordScopes)
        ?? EntityViewRecordScope.Primary;

      return new SettingsPanelBuilder('Create View')
        .input('name', 'Name', {
          placeholder: 'View name',
          value: model.name ?? '',
          autofocus: 'selectAll',
          required: true,
          errorMessage: { required: 'View name is required' },
        })
        .tabs('recordScope', 'View shows', {
          commands: scopeOptions.map(opt => new Command({ _id: opt.id, label: opt.label })),
          selected: selectedScope,
        })
        .footerRight(new Command({ label: 'Cancel', action: () => ctx.onCancel() }))
        .footerSplitButton(new Command({ label: 'Continue', action: () => wizard.next() }), [])
        .build();
    },
  };
}
